if($('.product').length){
    document.addEventListener('ShoptetDOMPageContentLoaded', function() {
        customProduct()
    });
    document.addEventListener('ShoptetPageSortingChanged', function() {
        customProduct();
    });
    document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
        customProduct();
    });
    $(document).ready(function(){
        customProduct();
    })

}

function customProduct(){
    let products = [];
    $('.product').each(function () {       
        if ($(this).find('.price-standard').length) {
            $(this).find('.prices').prepend($(this).find('.price-standard'));
        }
        if (!$(this).find('.prices .price-save').length) {
            
            $(this).find('.prices').append($(this).find('.price-save').clone());
        }

        let skuElement = $(this).find('span[data-micro="sku"]');
        let code = skuElement.text().trim();
        if (code) {
            products.push({ code: code});
        }
    });
    if (products.length === 0) {
        console.warn("❌ Nebyly nalezeny žádné kódy produktů.");
        return;
    }
    const storedLanguageString = localStorage.getItem('selectedLanguage');
    if (storedLanguageString) {
        var storedLanguage = JSON.parse(localStorage.getItem('selectedLanguage'));
        if(langName === storedLanguage.name){

        }
        else{
            let codes = products.map(product => product.code);
            const langSelector = storedLanguage.code;
            $.ajax({
                url: "https://tools.shopcode.cz/rdo/get_translations.php",
                type: "GET",
                data: { codes: codes.join(',') },
                dataType: "json",
                success: function (response) {
                    console.log("✅ Přijatá data:", response);
                    $.each(response, function (code, data) {
                        let productElement = $('.product span[data-micro="sku"]').filter(function () {
                            return $(this).text().trim() === code;
                        }).closest('.product');
                        if (productElement.length) {
                            if (data.translations && typeof data.translations === 'object' && !Array.isArray(data.translations)) {
                                let translation = data.translations[langSelector];
                  
                                if (translation && typeof translation === 'object') {
                                    productElement.find('.name').text(translation.name);
                                } else {
                                 //   productElement.find('.name').text(data.original_name);
                                }
                            } else {
                               // productElement.find('.name').text(data.original_name);
                            }
                        }
                    });
                },
                error: function (xhr, status, error) {
                    console.error("❌ Chyba při získávání překladů:", status, error);
                }
            });
        }
      
    } else {
        console.log("Žádná data v sessionStorage nejsou.");
    }

    
}